enum IntegrationType {
    TransactionalEmail = 1,  // SendGrid
    Invoicing = 2,           // Xero
    SSOMailboxSync = 3,      // Microsoft 365 / Google Workspace
    Payroll = 4,             // PurePro
}

export default IntegrationType;

